import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onChangeFactorStatusRes } from "./helper";

export const changeFactorStatus = async (data: {
  ids: Array<{ id: number; status: string; count: number }>;
}) => axios.post(Routes.CHANGE_FACTOR_STATUSES, { ...data });
// export const changeFactorStatus = async (data: {
//   status?: string;
//   ids: Array<number>;
// }) => axios.post(Routes.CHANGE_FACTOR_STATUSES, { ...data });

export const useChangeFactorStep = () =>
  useMutation({
    mutationKey: [Keys.CHANGE_FACTOR_STATUS_MUT],
    mutationFn: changeFactorStatus,
    onSuccess: (res) => {
      onChangeFactorStatusRes(res);
      return res;
    },
  });
